import React from 'react'
import classes from './Breadcrumb.module.scss';

function Breadcrumb({ t = "" , children}) {
    return (
        <div className={classes['Breadcrumb']}>{children ?? t}</div>
    )
}

export default Breadcrumb